import { styled } from '@mui/material';
import theme from 'theme';

const RootContainer = styled('div')(() => ({
  flexGrow: 1,
}));

const ListContainer = styled('ul')(() => ({
  marginTop: theme.spacing(1),
  overflow: 'hidden',
}));

export { RootContainer, ListContainer };
